import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import { DbooSliceType, DbooStatusType, OptOutDataType } from './types';

const initialState: DbooSliceType = {
  status: null,
};

const dbooSlice = createAppSlice({
  name: 'dboo',
  initialState,
  reducers: {
    setDbooStatus(state, action: PayloadAction<DbooStatusType>) {
      state.status = action.payload;
    },
    setOptOutData(state, action: PayloadAction<OptOutDataType>) {
      state.optOutData = action.payload;
    },
    removeDbooAccount(state) {
      state.status = 'INACTIVE';
      state.optOutData = null;
    },
    resetDboo: () => initialState,
  },
});

export const { setDbooStatus, setOptOutData, removeDbooAccount, resetDboo } =
  dbooSlice.actions;
export default dbooSlice.reducer;
